/**
 * The salon's staff noun (industry pack): "服务人员 / Staff" by default, "技师 / Therapist", "美甲师 / Nail technician" …
 * Every message may use {staff} (as written, e.g. "Therapist") or {staffLower} ("therapist"); the translators fill them
 * in unless the caller passes its own value. Set from the signed-in salon's business types (auth.tsx).
 */
import { staffNounFor, type L3 } from "@salon-pos/shared";

let nouns: L3 = staffNounFor([]);
let listeners: Array<() => void> = [];

export function setStaffNouns(types: readonly string[] | null | undefined): void {
  const next = staffNounFor(types ?? []);
  if (next.en === nouns.en && next.zh === nouns.zh && next.ms === nouns.ms) return;
  nouns = next;
  for (const l of listeners) l();
}
export const onStaffNounChange = (fn: () => void) => { listeners.push(fn); return () => { listeners = listeners.filter((x) => x !== fn); }; };
export const staffNounOf = (locale: string): string => nouns[(locale === "zh" || locale === "ms" ? locale : "en") as keyof L3];

/** Replace {vars} in a message; {staff} / {staffLower} default to the salon's staff noun. */
export function fill(locale: string, msg: string, vars: Record<string, string | number> = {}): string {
  return msg.replace(/\{(\w+)\}/g, (_, k: string) => {
    if (k in vars) return String(vars[k]);
    if (k === "staff") return staffNounOf(locale);
    if (k === "staffLower") return locale === "zh" ? staffNounOf(locale) : staffNounOf(locale).toLowerCase();
    return "{" + k + "}";
  });
}
